import React, { FC } from 'react'
import { LinkCompoundProps } from './LinkCompound.types'
import { buttonType, getLinkType } from '../../../../utils/linkUtil'

export const LinkCompound: FC<LinkCompoundProps> = props => {
  const {
    type,
    href,
    target,
    text,
    analytics,
    classes,
    shouldGrow,
    block,
    small,
    reversed,
    actionBlue,
    loading,
    isDestructive,
  } = props

  const destructive = isDestructive ? 'is-destructive' : ''

  const iconblockProperty =
    type && type === 'icon' && block && block === 'true' ? 'Button--icon--stroke' : ''
  const blockProperty = block ? 'Button--block u-flexAlignItemsCenter u-flexJustifyCenter' : ''
  const customPropertyForLoading =
    type && type === 'primary' && loading && loading === 'true' ? 'Button--primary--loading' : ''
  const smallProperty = small ? 'Button--small' : ''
  const reversedProperty = reversed ? 'Button--reversed' : ''
  const actionBlueProperty = actionBlue
    ? 'Button--secondary--action-blue u-textColorActionBlue'
    : ''
  const linkReverseProperty =
    type && type === 'link' && reversed && reversed === 'true' ? 'Link--reversed' : ''
  const typeProperty = buttonType(type)
  return (
    <a
      className={`${typeProperty} ${blockProperty} ${smallProperty} ${reversedProperty} ${actionBlueProperty} ${customPropertyForLoading} ${iconblockProperty} ${linkReverseProperty}
       ${classes ? classes.join(' ') : ''} ${shouldGrow ? ' u-flexGrow' : ''} ${destructive}`}
      href={href}
      data-testid='link'
      target={target}
      data-analytics={analytics}>
      {!typeProperty.includes('icon') && text}
      {type && type === 'primary' && loading && loading === 'true' && (
        <div className='Loading Loading--small'>
          <div className='Loading-indicator'></div>
          <div className='Loading-indicator'></div>
          <div className='Loading-indicator'></div>
          <div className='Loading-indicator'></div>
        </div>
      )}
      {type && type === 'icon' && (
        <div>
          <span className='u-hiddenVisually'>{text}</span>
          <span data-icon='expand_more' aria-hidden='true'>
            expand_more
          </span>
        </div>
      )}
    </a>
  )
}
